import './ApprovalsPage.css';

const MOCK_APPROVALS = [
  {
    id: 'apr-001',
    requestedBy: 'alice.rocha',
    requestedAt: '14:31:52',
    conn: 'srv-prod-01 / finance_db',
    sql: "UPDATE dbo.sales SET status = 'paid' WHERE invoice_id IN (8743, 8744, 8751)",
    ruleId: 'prod-dml-approval',
    ttlRemaining: '28 min',
    approvers: ['dba', 'senior_dba'],
  },
  {
    id: 'apr-002',
    requestedBy: 'marcos.lima',
    requestedAt: '13:47:10',
    conn: 'srv-prod-01 / hr_db',
    sql: "DELETE FROM dbo.employees WHERE department_id = 14 AND status = 'inactive'",
    ruleId: 'prod-dml-approval',
    ttlRemaining: '7 min',
    approvers: ['senior_dba'],
  },
  {
    id: 'apr-003',
    requestedBy: 'julia.melo',
    requestedAt: '13:12:44',
    conn: 'pg-prod-01 / app_billing',
    sql: "INSERT INTO billing.adjustments SELECT * FROM billing.pending_credits WHERE created_at < NOW() - INTERVAL '30 days'",
    ruleId: 'prod-dml-approval',
    ttlRemaining: '2 min',
    approvers: ['dba'],
  },
];

export default function ApprovalsPage() {
  return (
    <div className="approvals-page">
      <div className="approvals-header">
        <div>
          <div className="approvals-title">Aprovações Pendentes</div>
          <div className="approvals-sub">
            <span className="badge-warn">{MOCK_APPROVALS.length}</span> aguardando revisão
          </div>
        </div>
      </div>

      <div className="approvals-list">
        {MOCK_APPROVALS.map(a => (
          <div key={a.id} className={`approval-card ${a.ttlRemaining.startsWith('2') ? 'urgent' : ''}`}>
            <div className="approval-meta">
              <span className="approval-user">{a.requestedBy}</span>
              <span className="approval-time">{a.requestedAt}</span>
              <span className="approval-conn mono">{a.conn}</span>
              <span className={`ttl ${a.ttlRemaining.startsWith('2') ? 'urgent' : ''}`}>
                ⏱ {a.ttlRemaining}
              </span>
            </div>

            <div className="approval-sql">
              <pre>{a.sql}</pre>
            </div>

            <div className="approval-footer">
              <span className="approval-rule mono">regra: {a.ruleId}</span>
              <span className="approval-roles">
                roles: {a.approvers.map(r => <span key={r} className="role-chip">{r}</span>)}
              </span>
              <div className="approval-actions">
                <button className="btn-reject">✕ Rejeitar</button>
                <button className="btn-approve">✓ Aprovar</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
